import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '='
    },
    template: `
    <div class="well">
        <div class="heading01 type01">
            <h1>{{ 'trainingCompany.Training companies' | translate }}</h1>
            <a class="btn add" ng-click="vm.openModal()"
            >{{ 'trainingCompany.Add training company' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list"></list-factory-empty>
        <table
            class="data01"
            datatable
            dt-options="vm.DATATABLES"
            ng-if="!vm.list.loading && vm.list.items.length">
            <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('name')">
                        <a ng-click="vm.list.sortBy('name')">{{ 'trainingCompany.Name' | translate }}</a>
                    </th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td ng-if="item.name === ''">{{ 'company.default' | translate }}</td>
                    <td ng-if="item.name !== ''">{{ item.name }}</td>
                    <td>
                        <a ng-click="vm.openModal(item)" class="btn edit">
                            <span>{{ 'general.Edit' | translate }}</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor (lodash, DATATABLES, ListFactory, TrainingCompanyResource, ModalService) {
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.TrainingCompanyResource = TrainingCompanyResource;
        this.ModalService = ModalService;
        this.list = ListFactory.createWithPagination(TrainingCompanyResource.query.bind(TrainingCompanyResource));
    }

    $onInit () {
        this.list.fetch();
    }

    openModal (trainingCompany = null) {
        if (!trainingCompany) {
            trainingCompany = new this.TrainingCompanyResource();
        }
        this.ModalService.open({
            template: '<modals-training-company-form class="wrapper" uib-modal-instance="vm.$uibModalInstance" training-company="vm.trainingCompany"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.trainingCompany = trainingCompany;
            }
        }).then(() => {
            this.$onInit();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/trainingCompany/list/index.js